// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pY4V7YDtzKci7owhO9Hy{justify-content:space-between;padding:0 0 0 10px;display:flex}.pY4V7YDtzKci7owhO9Hy .zFlwxZhwn0QhjUlp_xaX{gap:8px;margin:17px 23px 0 0;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `pY4V7YDtzKci7owhO9Hy`,
	"leftActions": `zFlwxZhwn0QhjUlp_xaX`
};
export default ___CSS_LOADER_EXPORT___;
